module.exports = __webpack_public_path__ + "static/media/images-225x225.5bcd584c.jpg";